import styled from 'styled-components';

export const BreadcrumbCurtainStyled = styled.div`
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  text-transform: uppercase;
`;
